import { Controller } from "@hotwired/stimulus";

const LOCAL_STORAGE_KEY = "GraphQLExplorer.consoleState";

// Connects with data-controller="graphql-explorer-link"
export default class extends Controller<HTMLAnchorElement> {
  static values = {
    operationName: String,
    query: String,
  };

  declare operationNameValue: string;
  declare queryValue: string;

  save() {
    try {
      localStorage.setItem(
        LOCAL_STORAGE_KEY,
        JSON.stringify({
          query: this.queryValue,
          currentOperationName: this.operationNameValue,
        }),
      );
    } catch {
      // Continue to the explorer even if browser storage is unavailable.
    }
  }
}
